import { PrismicRichText, PrismicText } from '@prismicio/react';
import React from 'react';

import {
  PageBodyBlock_FaqsFields,
  PageBodyBlock_FaqsPrimary,
} from '../../../types/prismic';
import useFadeUp from '../../hooks/useFadeUp';
import H1orH2 from '../H1orH2';

interface BlockFAQsSliceProps {
  sliceIndex: number;
  slice: {
    primary: PageBodyBlock_FaqsPrimary;
    items: PageBodyBlock_FaqsFields[];
  };
}

const BlockFAQsSlice: React.FunctionComponent<BlockFAQsSliceProps> = (
  props
) => {
  useFadeUp('#block-faq .fade-up');

  function accordion(e) {
    const current = e.currentTarget;
    const { id } = current.dataset;
    const accordionContainer = document.querySelector(
      `.accordion[data-id="${id}"]`
    );
    const accordionTrigger = document.querySelector(
      `.accordion--trigger[data-id="${id}"]`
    );
    if (accordionContainer) accordionContainer.classList.toggle('is-active');
    if (accordionTrigger) accordionTrigger.classList.toggle('is-active');
  }
  const { slice, sliceIndex } = props;
  const { primary, items } = slice;
  const { eyebrow1, heading, divider } = primary;

  return (
    <section id="block-faq" className="bg--grey-2">
      <div className="container my-spacing-07 md:my-spacing-08">
        <div className="grid grid-cols-4 md:grid-cols-12">
          {divider === 'true' ? (
            <div className="col-span-4 pb-spacing-07 md:col-span-12 md:pb-20">
              <hr />
            </div>
          ) : (
            ''
          )}
          <div className="col-span-4 md:col-span-12 lg:col-span-2">
            <div className="eyebrow p5 line color--grey-4 fade-up mb-10 lg:mb-0">
              <PrismicText field={eyebrow1.richText} />
            </div>
          </div>
          <div className="col-span-4 md:col-span-12 lg:col-span-9">
            <H1orH2
              sliceIndex={sliceIndex}
              className="fade-up h2 color--primary-dark h2 color--primary-dark fade-up mb-20">
              <PrismicRichText
                field={heading.richText}
                components={{
                  heading1: ({ children }) => (
                    <span className="block">{children}</span>
                  ),
                  heading2: ({ children }) => (
                    <span className="block">{children}</span>
                  ),
                  heading3: ({ children }) => (
                    <span className="block">{children}</span>
                  ),
                }}
              />
            </H1orH2>

            {items.map((item, i) => (
              <div key={i}>
                <div
                  className="accordion--trigger flex justify-between"
                  onClick={accordion}
                  data-id={`${item.question.text}${i}`}>
                  <div className="h5 mb-0" itemProp="name">
                    <PrismicRichText field={item.question.richText} />
                  </div>
                  <div className="ml-auto">
                    <svg
                      width="26"
                      height="26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect
                        x=".5"
                        y=".5"
                        width="25"
                        height="25"
                        rx="12.5"
                        stroke="#B5B3AB"
                      />
                      <path
                        d="M16.664 12.168h-3.168V9h-1.344v3.168H9v1.344h3.152v3.152h1.344v-3.152h3.168v-1.344z"
                        fill="#B5B3AB"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  className="accordion"
                  data-id={`${item.question.text}${i}`}>
                  <div className="pt-6 md:pb-4 md:pr-10">
                    <div className="grid grid-cols-12">
                      <div className="col-span-12 md:col-span-10">
                        <div
                          className="color--grey-5 [&_p]:mb-2"
                          itemProp="text">
                          <PrismicRichText field={item.answer.richText} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="mb-10 mt-10" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default BlockFAQsSlice;
